import React from 'react'

const VendorAds = () => {
    return (
        <div className="w-full flex flex-col xl:flex-row">
            <div className="1.5xl:mt-0 h-fit min-h-fit 1.5xl:h-screen 1.5xl:min-h-fit w-full xl:w-1/2">
                <div className="h-[580px] xl:h-screen xl:min-h-[750px] bg-cover relative z-20"
                    style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/TrackScreenshotsBackground.png)` }}>

                    <div className="absolute w-[320px] h-[380px] 1.5xl:w-[540px] 1.5xl:h-[520px] bg-cover z-30 top-[175px] right-[100px] 1.5xl:right-[72px] 1.5xl:top-[200px]"
                        style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/TracksRearImage.png)` }}
                    ></div>
                    <div className={`absolute w-[320px] h-[350px] 1.5xl:w-[500px] 1.5xl:h-[580px] top-[75px] right-[20px]  1.5xl:-right-[140px] 1.5xl:top-[80px] bg-cover z-40 drop-shadow-2xl`}
                        style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/TracksFrontImage.png)` }}
                    ></div>
                </div>
            </div>

            <div className="h-fit w-full xl:w-1/2 flex flex-col 1.5xl:pl-[180px] 1.5xl:pr-[80px] px-[20px] py-[20px] xs:px-[40px] xs:py-[40px] md:px-[64px] md:py-[64px]">
                <h3 className="w-fit 1.5xl:mt-[44px] text-[36px] 1.5xl:text-[60px] text-left xl:text-left text-usersTitle font-allroundgothic font-[600] mb-0">
                    Your Listing.<br />Your Way.
                </h3>
                <p className="mt-[32px] 1.5xl:mt-[24px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>CharmHealthHub allows you to fully manage your listing through your Vendor Portal.
                </p>
                <p className="xl:mt-[16px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>
                    Through the portal, you can create a dedicated listing page with a unique URL that allows you to showcase your product at its best.
                </p>

                <p className="xl:mt-[16px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>
                    Keep your listing page on brand with your logo; banner image; website and social media links, images, videos, product details, pricing info and more.
                </p>
                <p className="xl:mt-[16px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>

                    Keep users informed about your latest developments by keeping your listing up-to-date.
                </p>
                <p className="xl:mt-[16px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>

                    Engage with users directly through CharmHealthHub and get feedback through reviews.
                </p>
            </div>
        </div>
    )
}

export default VendorAds